import * as React from 'react'
import Styles from './Toast.module.css'
import { ToastProps } from './interfaces'

export const Toast: React.FunctionComponent<ToastProps> = ({ toast }) => (
	<div>
		<div className={`${Styles.toast}  ${toast.style && Styles[toast.style]}`}>
			<div>{toast.title}</div>
			<div>{toast.body}</div>
		</div>
	</div>
)
